<template>
    <div class="card">
        <player :option="{...option, url: 'https://storage.yandexcloud.net/lukoil-video/'+ content.video_id +'-720.mp4'}" :style="style" @get-instance="getInstance"
                @keydown.right="console.log(1)"
        />
        <div class="pa-4">{{ content.title }}</div>
    </div>
</template>

<script>
import player from './Player.vue';
export default {
  components: {
    player,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      option: {
        url            : '',
        volume         : 0.5,
        isLive         : false,
        muted          : false,
        autoplay       : false,
        setting        : true,
        loop           : true,
        playbackRate   : true,
        fullscreen     : true,
        miniProgressBar: true,
        mutex          : true,
        backdrop       : true,
        playsInline    : true,
        theme          : '#e2173d',
        lang           : navigator.language.toLowerCase(),
        whitelist      : ['*'],
      },
      style: {
        width : '100%',
        height: '500px',
      },
    };
  },
  computed: {
    url() {
      return this.content.video_id;
    },
  },
  methods: {
    getInstance(art) {
      art.hotkey.add(39, () => {
        art.currentTime = art.currentTime + 10;
      });
      art.hotkey.add(37, () => {
        art.currentTime = art.currentTime - 10;
      });
    },
  },
};
</script>

